import { Highlight } from './highlight.js'

export * from './highlight.js'

export default Highlight
